import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClienteService } from '../http-cliente.service';

@Injectable({
  providedIn: 'root',
})
export class AwardsService {
  private readonly url = environment.apiURL;
  constructor(private readonly _http: HttpClienteService) {}

  getRecognitionList(code: any) {
    const query = `${this.url}/wcl-document/recognition-list-by-code?code=${code}`;

    return this._http.get(query);
  }
  getAwardsSummary(code: number | string, file) {
    const query = `${this.url}/wcl-document/summary-recognitions-by-code-file?code=${code}&idRecognitionFile=${file}`;
    return this._http.get(query);
  }
  getDetailByList(code: string, file) {
    const query = `${this.url}/wcl-document/homologation-by-code-file?code=${code}&idRecognitionFile=${file}`;
    return this._http.get(query);
  }
  getDataDetailHomologation(
    code: number | string,
    idHomologation,
    idRecognitionFile
  ) {
    const query = `${this.url}/wcl-document/details-recognitions-by-id-homologation?code=${code}&idHomologation=${idHomologation}&idRecognitionFile=${idRecognitionFile}`;
    return this._http.get(query);
  }

  getExcelData(code: any, file) {
    const query = `${this.url}/wcl-document/download-recognitions-by-id-recognition-file?code=${code}&idRecognitionFile=${file}`;
    return this._http.get(query);
  }

  getAllGlossaryRebate() {
    const query = `${this.url}/wcl-customer/get-all-glossary-rebate`;
    return this._http.get(query);
  }

  getAvailableMonths(code: any) {
    const query = `${this.url}/wcl-document/get-available-month?code=${code}&path=regla-contratos`;
    return this._http.get(query);
  }

  getSummaryByCustomerPeriod(data: any) {
    const query = `${this.url}/wcl-customer/summary-by-customer-period`;
    return this._http.post(query, data);
  }

  getContractRules(date: string, code: string) {
    const query = `${this.url}/wcl-customer/get-contract-rules?date=${date}&code=${code}`;
    return this._http.get(query);
  }
}
